up.compiler('[break-long-words]', (element) => {

  const wordBreaks = {
    'Fahrsicherheitstraining': "Fahr\xADsicherheits\xADtraining",
    'Fahrsicherheitszentrum': 'Fahr\xADsicherheits\xADzentrum',
    'Kreisverkehrswacht': 'Kreis\xADverkehrswacht',
    'Berufsgenossenschaft': 'Berufs\xADgenossenschaft',
    'Widerrufsbelehrung': 'Widerrufs\xADbelehrung',
    'Verkehrsübungsplatz': 'Verkehrs\xADübungsplatz',
  }

  const keys = Object.keys(wordBreaks)

  function textNodes(node){
    let textNodes = []
    let walk = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null, false);

    let nextNode
    while (nextNode = walk.nextNode()) {
      textNodes.push(nextNode);
    }
    return textNodes;
  }

  keys.forEach((key) => {
    let nodes = textNodes(element)
    nodes.forEach((node) => {
      node.textContent = node.textContent.replace(new RegExp(key, 'gi'), wordBreaks[key])
    })
  })

})
